import { httpWithAuth } from '~/clients';
import { getCreditStatus } from '~/constants/endpoints';
import { CreditStatusResponse } from './contracts/FinanceData';

type OwnProps = {
  userId: string;
  tradeEquity: number;
};

export default function fetchCreditStatus({ userId, tradeEquity }: OwnProps) {
  return httpWithAuth.get<Partial<CreditStatusResponse>>(
    `${getCreditStatus(userId)}?tradeEquity=${tradeEquity}`
  );
}
